// 
// NReco PivotTable Extensions
// Author: Vitaliy Fedorchenko
// 
// Copyright (c) nrecosite.com - All Rights Reserved
// THIS CODE AND INFORMATION ARE PROVIDED "AS IS" WITHOUT WARRANTY OF ANY 
// KIND, EITHER EXPRESSED OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND/OR FITNESS FOR A
// PARTICULAR PURPOSE.
//
import jQuery from 'jquery'

(function () {
	var $;

	$ = jQuery;

	var applyDrillDownHandler = function (wrapper, pvtData, tElem) {
		if (typeof wrapper.options.drillDownHandler != "function")
			return;
		$(tElem).addClass('pvtValDrillDown').on("click", "td.pvtVal,td.pvtTotal", function () {
			var cssClasses = $(this).attr('class').split(' ');
			var colIdx = -1, rowIdx = -1;
			if ($.inArray("pvtVal", cssClasses) >= 0) {
				$.each(cssClasses, function () {
					if (this.indexOf('row') == 0) rowIdx = parseInt(this.substring(3));
					if (this.indexOf('col') == 0) colIdx = parseInt(this.substring(3));
				});
			}
			if ($.inArray("rowTotal", cssClasses) >= 0) {
				var dataFor = $(this).attr('data-for');
				rowIdx = parseInt(dataFor.substring(3));
			}
			if ($.inArray("colTotal", cssClasses) >= 0) {
				var dataFor = $(this).attr('data-for');
				colIdx = parseInt(dataFor.substring(3));
			}
			var dataFilter = {};
			if (colIdx >= 0) {
				for (var cAttrIdx = 0; cAttrIdx < pvtData.colAttrs.length; cAttrIdx++) {
					var colKeys = pvtData.getColKeys();
					var cValues = colKeys[colIdx];
					dataFilter[pvtData.colAttrs[cAttrIdx]] = cValues[cAttrIdx];
				}
			}
			if (rowIdx >= 0) {
				for (var rAttrIdx = 0; rAttrIdx < pvtData.rowAttrs.length; rAttrIdx++) {
					var rowKeys = pvtData.getRowKeys();
					var rValues = rowKeys[rowIdx];
					dataFilter[pvtData.rowAttrs[rAttrIdx]] = rValues[rAttrIdx];
				}
			}
			wrapper.options.drillDownHandler(dataFilter);
		});
	};

	var sortDataByCol = function (pvtData, sortByColIdx, ascDesc) {
		var sortRowVals = [];
		var rowKey, colKey, aggregator, i;

		pvtData.sorted = false; // flush row/col order
		var rowKeys = pvtData.getRowKeys();
		var colKeys = pvtData.getColKeys();

		for (i in rowKeys) {
			rowKey = rowKeys[i];
			colKey = sortByColIdx != null ? colKeys[sortByColIdx] : [];
			aggregator = pvtData.getAggregator(rowKey, colKey);
			sortRowVals.push({ val: aggregator.value(), key: rowKey });
		}
		sortRowVals.sort(function (a, b) {
			return ascDesc * $.pivotUtilities.naturalSort(a.val, b.val);
		});
		pvtData.rowKeys = [];
		for (i = 0; i < sortRowVals.length; i++)
			pvtData.rowKeys.push(sortRowVals[i].key);
		pvtData.sorted = true;
	};

	var sortDataByRow = function (pvtData, sortByRowIdx, ascDesc) {
		var sortColVals = [];
		var rowKey, colKey, aggregator, i;

		pvtData.sorted = false; // flush row/col order
		var rowKeys = pvtData.getRowKeys();
		var colKeys = pvtData.getColKeys();

		for (i in colKeys) {
			colKey = colKeys[i];
			rowKey = sortByRowIdx != null ? rowKeys[sortByRowIdx] : [];
			aggregator = pvtData.getAggregator(rowKey, colKey);
			sortColVals.push({ val: aggregator.value(), key: colKey });
		}
		sortColVals.sort(function (a, b) {
			return ascDesc * $.pivotUtilities.naturalSort(a.val, b.val);
		});
		pvtData.colKeys = [];
		for (i = 0; i < sortColVals.length; i++)
			pvtData.colKeys.push(sortColVals[i].key);
		pvtData.sorted = true;
	};

	var applySortHandler = function (wrapper, pvtData, opts, tElem, refreshTable) {
        const tabId = opts.nrecoTabId;
        const toggleTotal = $(tElem).find(".pvtTotal, .pvtTotalLabel, .pvtGrandTotal")

        if (!localStorage.getItem(tabId)) {
            toggleTotal.show()
        } else {
            const parse = JSON.parse(localStorage.getItem(tabId)).total;
           
            if (parse) {
                toggleTotal.show()
            } else {
                toggleTotal.hide()
            }
        }

        // .find(".pvtTotal, .pvtTotalLabel, .pvtGrandTotal").hide();
		var applyAscDescClass = function ($elem, direction) {
			$elem.addClass(direction == "desc" ? "pvtSortDesc" : "pvtSortAsc");
		};
		var applySort = function (keys, labels, optSortKey, doSort) {
			labels.click(function () {
				var $lbl = $(this);
				var keyIdx = $lbl.data('key_index');
				var key = keys[keyIdx];

				if ($lbl.hasClass("pvtSortAsc")) {
					doSort(pvtData, keyIdx, -1);
					if (!opts.sort)
						opts.sort = {};
					opts.sort.direction = "desc";
					opts.sort[optSortKey] = key;
				} else if ($lbl.hasClass("pvtSortDesc")) {
					pvtData.sorted = false;
					delete opts.sort[optSortKey];
				} else {
					doSort(pvtData, keyIdx, 1);
					if (!opts.sort)
						opts.sort = {};
					opts.sort.direction = "asc";
					opts.sort[optSortKey] = key;
				}
				refreshTable();
			}).each(function () {
				if (opts.sort && opts.sort[optSortKey]) {
					var $lbl = $(this);
					var key = keys[$lbl.data('key_index')];
					if (key.join('_') == opts.sort[optSortKey].join('_')) {
						applyAscDescClass($lbl, opts.sort.direction);
					}
				}
			});
		};
		var markSortableLabels = function (keys, $labels) {
			var i = 0;
			$labels.each(function () {
				var $lbl = $(this);
				var lblText = $.trim( $lbl.text() );
				var k = keys[i];
				if (k!=null && k.length>0 && k[k.length - 1] == lblText) {
					$lbl.addClass("pvtSortable").data('key_index', i);
					i++;
					return;
				}
			});
		};
		if (wrapper.options.sortByColumnsEnabled) {
			var colKeys = pvtData.getColKeys();
			markSortableLabels(colKeys, $(tElem).find('.pvtColLabel[colspan="1"]'));
			applySort(colKeys, $(tElem).find('.pvtColLabel.pvtSortable[colspan="1"]'), "column_key", sortDataByCol);
		}

		if (wrapper.options.sortByRowsEnabled) {
			var rowKeys = pvtData.getRowKeys();
			markSortableLabels(rowKeys, $(tElem).find('.pvtRowLabel[rowspan="1"]'));
			applySort(rowKeys, $(tElem).find('.pvtRowLabel.pvtSortable[rowspan="1"]'), "row_key", sortDataByRow);
		}

		// sort by label
		if (wrapper.options.sortByLabelEnabled) {
			$(tElem).find('.pvtAxisLabel').each(function () {
				var $axisLbl = $(this);
				var axisName = $.trim($axisLbl.text());
				var isColAxis = $axisLbl.parent().find('.pvtColLabel').length > 0;
				$axisLbl.data('axis_name', axisName);
				$axisLbl.addClass(isColAxis ? "pvtSortableCol" : "pvtSortableRow");
				if (!opts.sort
					|| (isColAxis && (!opts.sort.row_key && !opts.sort.row_totals))
					|| (!isColAxis && (!opts.sort.column_key && !opts.sort.col_totals))) {
					applyAscDescClass($axisLbl, opts.sort && opts.sort.labels && opts.sort.labels[axisName] == "desc" ? "desc" : "asc");
				}
			}).click(function () {
				var $axisLbl = $(this);
				var axisName = $axisLbl.data('axis_name');
				var isColAxis = $axisLbl.hasClass('pvtSortableCol');
				if (!opts.sort)
					opts.sort = {};
				if (!opts.sort.labels)
					opts.sort.labels = {};
				if ($axisLbl.hasClass("pvtSortAsc")) {
					//doSort(pvtData, keyIdx, -1);
					opts.sort.labels[axisName] = "desc";
				} else {
					opts.sort.labels[axisName] = "asc";
				}
				pvtData.sorted = false;
				// reset by val
				if (isColAxis) {
					opts.sort.row_key = null;
					opts.sort.row_totals = false;
				} else {
					opts.sort.column_key = null;
					opts.sort.col_totals = false;
				}
				refreshTable();
			});
		}

		$(tElem).find('tr:last .pvtTotalLabel').addClass("pvtTotalColSortable").click(function () {
			var $lbl = $(this);
			if ($lbl.hasClass("pvtSortAsc")) {
				sortDataByRow(pvtData, null, -1);
				opts.sort = { direction: "desc", row_totals: true };
			} else if ($lbl.hasClass("pvtSortDesc")) {
				pvtData.sorted = false;
				opts.sort = null;
			} else {
				sortDataByRow(pvtData, null, 1);
				opts.sort = { direction: "asc", row_totals: true };
			}
			refreshTable();
		}).each(function () {
			var $lbl = $(this);
			if (opts.sort && opts.sort.row_totals) {
				applyAscDescClass($lbl, opts.sort.direction);
			}
		});

		$(tElem).find('tr:first .pvtTotalLabel').addClass("pvtTotalRowSortable").click(function () {
			var $lbl = $(this);
			if ($lbl.hasClass("pvtSortAsc")) {
				sortDataByCol(pvtData, null, -1);
				opts.sort = { direction: "desc", col_totals: true };
			} else if ($lbl.hasClass("pvtSortDesc")) {
				pvtData.sorted = false;
				opts.sort = null;
			} else {
				sortDataByCol(pvtData, null, 1);
				opts.sort = { direction: "asc", col_totals: true };
			}
			refreshTable();
		}).each(function () {
			var $lbl = $(this);
			if (opts.sort && opts.sort.col_totals) {
				applyAscDescClass($lbl, opts.sort.direction);
			}
		});

	};
	var preparePivotData = function (pvtData) {
		var i, j, aggregator;
		var colKeys = pvtData.getColKeys();
		var rowKeys = pvtData.getRowKeys();
		var data = [];
		var totalsRow = [];
		var totalsCol = [];
		for (i in rowKeys) {
			data[i] = [];
			for (j in colKeys) {
				aggregator = pvtData.getAggregator(rowKeys[i], colKeys[j]);
				data[i][j] = aggregator.value();
			}
			totalsCol[i] = pvtData.getAggregator(rowKeys[i], []).value();
		}
		for (j in colKeys) {
			totalsRow[j] = pvtData.getAggregator([], colKeys[j]).value();
		}
		var grandTotalAggregator = pvtData.getAggregator([], []);
		return {
			columnKeys: colKeys,
			columnAttrs : pvtData.colAttrs,
			rowKeys: rowKeys,
			rowAttrs : pvtData.rowAttrs, 
			matrix: data,
			totals: { row: totalsRow, column : totalsCol, grandTotal : grandTotalAggregator.value() }
		};
	};

	window.NRecoPivotTableExtensions = function (options) {
		this.options = $.extend({},NRecoPivotTableExtensions.defaults, options);
	};

	window.NRecoPivotTableExtensions.prototype.sortDataByOpts = function (pvtData, opts) {
		// apply label sort direction modifiers
		if (!pvtData.__origSorters) {
			pvtData.__origSorters = pvtData.sorters;
			pvtData.sorters = function (attr) {
				var comparer = null;
				if ($.isFunction(pvtData.__origSorters)) {
					comparer = pvtData.__origSorters(attr);
				} else if (pvtData.__origSorters != null && pvtData.__origSorters[attr]!=null) {
					comparer = pvtData.__origSorters[attr];
				}
				if (!comparer)
					comparer = $.pivotUtilities.naturalSort;
				if (opts && opts.sort && opts.sort.labels && opts.sort.labels[attr] == "desc") {
					return function (a, b) {
						return -comparer(a, b);
					};
				}
				return comparer;
			};
		}

		pvtData.sorted = false;
		if (opts && opts.sort) {
			// sort by value
			var ascDesc = opts.sort.direction == "desc" ? -1 : 1;
			if (opts.sort.column_key) {
				var colKeys = pvtData.getColKeys();
				var sortByKeyStr = opts.sort.column_key.join('_');
				for (var i in colKeys)
					if (sortByKeyStr == colKeys[i].join('_')) {
						sortDataByCol(pvtData, i, ascDesc);
					}
			} else if (opts.sort.row_key) {
				var rowKeys = pvtData.getRowKeys();
				var sortByKeyStr = opts.sort.row_key.join('_');
				for (var i in rowKeys)
					if (sortByKeyStr == rowKeys[i].join('_')) {
						sortDataByRow(pvtData, i, ascDesc);
					}
			} else if (opts.sort.row_totals) {
				sortDataByRow(pvtData, null, ascDesc);
			} else if (opts.sort.col_totals) {
				sortDataByCol(pvtData, null, ascDesc);
			}
		}
	};
	window.NRecoPivotTableExtensions.prototype.wrapTableRenderer = function (tableRenderer) {
		var wrapper = this;
		return function (pvtData, opts) {
			var tElem, refreshTable, wrapTable;

			wrapper.sortDataByOpts(pvtData, opts);
			tElem = tableRenderer(pvtData, opts);
			wrapTable = function ($t) {
				if (wrapper.options.wrapWith) {
					var $w = $(wrapper.options.wrapWith);
					$w.append($t);
					$t = $w;
				}
				return $t;
			};

			refreshTable = function () {
				var newTbl = tableRenderer(pvtData, opts);
				applyDrillDownHandler(wrapper,pvtData,newTbl);
				applySortHandler(wrapper, pvtData, opts, newTbl, refreshTable);
				$(tElem).replaceWith(newTbl);
				tElem = newTbl;
				if (wrapper.options.fixedHeaders)
					wrapper.initFixedHeaders( $(tElem), true, opts.fixedHeaders);
				if (typeof wrapper.options.onSortHandler == 'function')
					wrapper.options.onSortHandler(opts.sort ? opts.sort : {});
			};
			applyDrillDownHandler(wrapper, pvtData, tElem);
			applySortHandler(wrapper, pvtData, opts, tElem, refreshTable);
			return wrapTable(tElem);
		};
	};

	window.NRecoPivotTableExtensions.prototype.initFixedHeaders = function ($t, isWrapped, fixedHeaders) {
		if ($t.length == 0)
			return;
		var wrapper = this;
		var $scrollDiv = isWrapped ? $t.closest('.pvtFixedHeaderOuterContainer') : $t.parent();
		var fixedHeadersOpts = typeof fixedHeaders === "object" ? fixedHeaders : {};
		if (this.fixedHeaders)
			this.fixedHeaders.destroy();
		this.fixedHeaders = new NRecoFixedHeaders($scrollDiv, $t,
			fixedHeadersOpts.smooth === true ? true : false,
			fixedHeadersOpts.rows === false ? false : true,
			fixedHeadersOpts.columns === false ? false : true,
			fixedHeadersOpts.disableByAreaFactor ? fixedHeadersOpts.disableByAreaFactor : 0.5,
			fixedHeadersOpts.useSticky === false ? false : true
		);		
	};

	
	// -- START: Fixed headers plugin
	function NRecoFixedHeaders($containerElem, $t, smooth, rowHdrEnabled, colHdrEnabled, disableByAreaFactor, useSticky) {
		this.$containerElem = $containerElem;
		this.$t = $t;
		this.fixedByTop = [];
		this.fixedByLeft = [];
		this.smooth = smooth;
		this.rowHdrEnabled = rowHdrEnabled;
		this.colHdrEnabled = colHdrEnabled;
		this.disableByAreaFactor = disableByAreaFactor;

		this.useSticky = useSticky;
		if (typeof useSticky !== "boolean") {
			// test for sticky support
			var testDiv = document.createElement('div');
			testDiv.style.position = 'sticky';
			this.useSticky = testDiv.style.position.indexOf('sticky') >= 0;
		}
		this.init();
	}
	NRecoFixedHeaders.prototype.buildFixedHeaders = function (syncUpdate) {
		var $scrollDiv = this.$containerElem;

		var $t = this.$t;
		var fixedHeaders = [];
		var fixedByTop = this.fixedByTop = [];
		var fixedByLeft = this.fixedByLeft = [];
		var rowHdrEnabled = this.rowHdrEnabled;
		var colHdrEnabled = this.colHdrEnabled;

		$scrollDiv.addClass("pvtFixedHeaderOuterContainer");
		$t.addClass('pvtFixedHeader');
		var colTotalsTH = $t.find('th.pvtTotalLabel');
		if (colTotalsTH.length > 0) {
			$t.addClass("pvtHasTotalsLastColumn");
		}
		var thNodes = $t[0].getElementsByTagName('TH');
		for (var i = 0; i < thNodes.length; i++) {
			var th = thNodes[i];

			var isAxisLabel = th.className.indexOf('pvtAxisLabel') >= 0;
			var isTotalLabel = th.className.indexOf('pvtTotalLabel') >= 0;
			var isPvtColumn = !isAxisLabel && (th.className.indexOf('pvtColLabel') >= 0 || (isTotalLabel && i>0 && thNodes[i-1].className.indexOf("pvtColLabel")>=0) );
			var isPvtRow = !isAxisLabel && (th.className.indexOf('pvtRowLabel') >= 0 || (isTotalLabel && i>0 && thNodes[i-1].className.indexOf("pvtRowLabel")>=0));

			var entry = {
				th: th,
				isCol: isPvtColumn,
				isRow: isPvtRow
			};
			if (!isPvtColumn)
				entry.fixedLeft = true;
			if (!isPvtRow) {
				entry.fixedTop = true;
			}

			var wrapDiv = null;
			if (th.childNodes.length == 1 && th.childNodes[0].tagName == "DIV") {
				wrapDiv = th.childNodes[0];
				wrapDiv.className = "pvtFixedHeader";
			} else {
				wrapDiv = document.createElement('div');
				wrapDiv.className = 'pvtFixedHeader';
				if (entry.isCol || entry.isRow)
					wrapDiv.setAttribute('title', th.textContent);
				if (th.childNodes.length > 0) {
					while (th.childNodes.length > 0)
						wrapDiv.appendChild(th.childNodes[0]);
				} else {
					wrapDiv.textContent = th.textContent;
				}
				th.appendChild(wrapDiv);
			}
			entry.el = wrapDiv;

			fixedHeaders.push(entry);
		}

		function getElementRectLegacy(el) {
			return { height: el.clientHeight, top: el.offsetTop, left: el.offsetLeft };
		}
		function getElementRectWithGetBounding(el) {
			var rect = el.getBoundingClientRect();
			return { height: rect.height, top: rect.top, left: rect.left };
		}
		var getElementRect = $scrollDiv[0].getBoundingClientRect ? getElementRectWithGetBounding : getElementRectLegacy;
		if (this.useSticky) {
			var tblRect = getElementRect($t[0]);
			for (var i = fixedHeaders.length-1; i >=0; i--) {
				var entry = fixedHeaders[i];
				var thRect = getElementRect(entry.th);
				entry.offsetTop = thRect.top - tblRect.top;
				entry.offsetLeft = thRect.left - tblRect.left;
				entry.height = thRect.height;
			}
			var setFixedHeaderHeightTopLeft = function () {
				for (var i = 0; i < fixedHeaders.length; i++) {
					var entry = fixedHeaders[i];
					entry.el.style.height = entry.height + "px";
					if (colHdrEnabled && entry.fixedTop) {
						entry.th.style.top = entry.offsetTop + "px";
					}
					if (rowHdrEnabled && entry.fixedLeft) {
						entry.th.style.left = entry.offsetLeft + "px";
					}
				}
				$scrollDiv.addClass('pvtStickyFixedHeader');
				if (navigator.userAgent.indexOf('Chrome') !== -1)
					$scrollDiv.addClass("pvtStickyChromeFixedHeader");	//css workaround for known Chrome issue with z-index and position:sticky			
			};
			if (window.requestAnimationFrame && !syncUpdate)
				window.requestAnimationFrame(setFixedHeaderHeightTopLeft);
			else
				setFixedHeaderHeightTopLeft();
		} else {
			// fallback that moves headers on scroll
			for (var i = fixedHeaders.length - 1; i >= 0; i--) {
				var entry = fixedHeaders[i];
				var thRect = getElementRect(entry.th);
				entry.height = thRect.height;
				if (colHdrEnabled && entry.fixedTop) {
					fixedByTop.push({
						el: entry.el,
						th: entry.th,
						top: 0,
						lastTop: 0
					});
				}
				if (rowHdrEnabled && entry.fixedLeft) {
					fixedByLeft.push({
						el: entry.el,
						th: entry.th,
						left: 0,
						lastLeft: 0,
					});
				}
			}
			var setFixedHeaderHeight = function () {
				for (var i = 0; i < fixedHeaders.length; i++) {
					var entry = fixedHeaders[i];
					entry.el.style.height = entry.height + "px";
				}
			};
			if (window.requestAnimationFrame && !syncUpdate)
				window.requestAnimationFrame(setFixedHeaderHeight);
			else
				setFixedHeaderHeight();
		}

	};
	NRecoFixedHeaders.prototype.refreshHeaders = function (top, left) {
		var fixedByLeft = this.fixedByLeft;
		var fixedByTop = this.fixedByTop;
		var setLeftTop = function () {
			var newPos;
			var entry;
			for (var i = 0; i < fixedByLeft.length; i++) {
				entry = fixedByLeft[i];
				newPos = (left + entry.left);
				if (newPos != entry.lastLeft) {
					entry.lastLeft = newPos;
					entry.el.style.left = newPos + "px";
				}
			}
			for (var i = 0; i < fixedByTop.length; i++) {
				entry = fixedByTop[i];
				newPos = (top + entry.top);
				if (newPos != entry.lastTop) {
					entry.lastTop = newPos;
					entry.el.style.top = newPos + "px";
				}
			}
		};
		if (window.requestAnimationFrame)
			window.requestAnimationFrame(setLeftTop);
		else
			setLeftTop();
	};

	NRecoFixedHeaders.prototype.destroy = function () {
		this.$containerElem.off("scroll wheel");
		if (this.resizeHandler)
			$(window).off('resize', this.resizeHandler);
		this.fixedByTop = null;
		this.fixedByLeft = null;
		this.$containerElem = null;
		this.$t = null;
	};

	NRecoFixedHeaders.prototype.refresh = function () {
		var instance = this;
		instance.$t.find('div.pvtFixedHeader').each(function () {
			this.style.height = 'auto';
			if (!instance.useSticky) {
				this.style.top = '0px';
				this.style.left = '0px';
			}
		});
		instance.$containerElem.removeClass("pvtStickyFixedHeader");
		instance.buildFixedHeaders(true);
		if (!this.useSticky) {
			instance.refreshHeaders(instance.$containerElem[0].scrollTop, instance.$containerElem[0].scrollLeft);
		}
	};

	NRecoFixedHeaders.prototype.init = function () {
		this.buildFixedHeaders();
		var instance = this;

		if (!this.useSticky) {
			// emulate position sticky by handling scroll event
			var scrollElem = this.$containerElem[0];
			var timeout = null;
			var prevTop = -1;
			var prevLeft = -1;
			var refreshHandler = this.smooth ?
				instance.refreshHeaders :
				function (top, left) {
					if (timeout)
						clearTimeout(timeout);
					this.$containerElem.addClass("pvtFixedHeadersOutdated");
					timeout = setTimeout(function () {
						timeout = null;
						instance.$containerElem.removeClass("pvtFixedHeadersOutdated");
						instance.refreshHeaders(top, left);
					}, 300);
				};
			this.$containerElem.on("scroll", function (evt) {
				var top = scrollElem.scrollTop;
				var left = scrollElem.scrollLeft;
				if (top != prevTop || left != prevLeft) {
					prevTop = top;
					prevLeft = left;
					refreshHandler.call(instance, top, left);
				}
			});
			this.$containerElem.scroll();
		}

		// resize handling
		var containerWidth = this.$containerElem[0].clientWidth;
		this.resizeHandler = function () {
			var newWidth = instance.$containerElem[0].clientWidth;
			if (containerWidth == newWidth) {
				return; // nothing is changed
			}
			containerWidth = newWidth;
			var refreshFixedHeaders = function () {
				instance.refresh();
			};
			if (window.requestAnimationFrame)
				window.requestAnimationFrame(refreshFixedHeaders);
			else
				refreshFixedHeaders();
		};
		$(window).on('resize', this.resizeHandler);
	};
	// -- END: Fixed headers plugin 	
	
	
	window.NRecoPivotTableExtensions.prototype.wrapPivotExportRenderer = function (renderer) {
		var wrapper = this;
		return function (pvtData, opts) {
			wrapper.sortDataByOpts(pvtData, opts);
			var elem = renderer(pvtData, opts);
			$(elem).addClass("pivotExportData").data("getPivotExportData", function () { return preparePivotData(pvtData); });
			return elem;
		};
	};

	window.NRecoPivotTableExtensions.defaults = {
		drillDownHandler: null, // function(filterObj) where filterObj like {'dim1', 'value1', 'dim2', 'value2'}
		wrapWith: null, // element for wrapping table
		onSortHandler : function(sortOpts) { }, // called when sort is changed, sortOpts = current state (rendererOptions.sort entry)
		sortByLabelEnabled: true,
		sortByColumnsEnabled: true,
		sortByRowsEnabled: true,
		fixedHeaders : false,
        tabId: null
	};

}).call(this);